import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import routes from './main-routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
  },
  routes
})

const userSessionActive = () => store.state.user
const accountSelected = () => store.state.account

router.beforeEach(async (to, from, next) => {
  // put the page title in the browser tab
  document.title = to.meta.title

  // if there can be a problem if the user leaves a page, for example losing data in an unfinished
  // form, we will show a modal so the user can confirm their intention to leave the page.
  if (store.state.navConfirmation) {
    router.app.$root.$emit('show::custom::modal', 'confirm-navigation')
    return next(false)
  }

  const routeIsPrivate = to.matched.some(record => record.meta.requiresAuth)

  // If there is no user session in the store, check the localstorage
  !userSessionActive() && await store.dispatch('handleSession')

  if (to.query.user) {
    store.dispatch('createAutoPasswordResetTuple', to.query.user)
  }

  // if the user hasn't selected an account, take them to the page to choose one
  if (userSessionActive() && !accountSelected() && to.name !== 'Accounts') {
    if (from.name !== 'Accounts' && to.name !== 'btTourNewWindow' && to.name !== 'ecommTourNewWindow') {
      return next('/accounts')
    }
  }
  if (routeIsPrivate && !userSessionActive()) {
    next('/')
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  // window.ga is the global variable for google analytics
  if (window.ga) {
    window.ga('set', 'page', to.path)
    window.ga('send', 'pageview')
  }
})

export default router
